// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__Acvcd","colMin":"styles_colMin__3BUN3","colCheckbox":"styles_colCheckbox__1tuWo"};